/** Fingerprint for ordered raster files (order + identity by name/size). */
export function fingerprintRasterFiles(files: File[]): string {
    return files.map((f, i) => `${i}:${f.name}:${f.size}`).join('|');
}

export function fingerprintPdfFile(file: File | null): string {
    if (!file) return 'empty';
    return `pdf:${file.name}:${file.size}`;
}
